export default async function (handle, selectedVariantId = null) {
    const query = new URLSearchParams();
    query.append('view', 'object-json');

    if (selectedVariantId) {
        query.append('variant', selectedVariantId);
    }

    const url = `/products/${handle}?${query.toString()}`;

    const response = await fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html',
        },
        credentials: 'include',
    });

    const htmlText = await response.text();
    const html = document.createElement('div');
    html.innerHTML = htmlText;

    return JSON.parse(html.querySelector('[data-json-response]').innerHTML);
}
